import {
  getRealtimeHazardEventList,
  getRealtimeInquireList,
} from '@/api/gddlysjghazardeventserv'

export default {
  state: {
    state_GdDlysjgHazardEvent_GetRealtimeHazardEventListResult: null,
    state_GdDlysjgHazardEvent_GetRealtimeInquireListResult: null,
  },
  mutations: {
    SET_GDDLYSJGHAZARDEVENT_GETREALTIMEHAZARDEVENTLIST_RESULT: (state, rst) => {
      state.state_GdDlysjgHazardEvent_GetRealtimeHazardEventListResult = rst;
    },
    SET_GDDLYSJGHAZARDEVENT_GETREALTIMEINQUIRELIST_RESULT: (state, rst) => {
      state.state_GdDlysjgHazardEvent_GetRealtimeInquireListResult = rst;
    },
  },
  actions: {
    GdDlysjgHazardEventServ_GetRealtimeHazardEventList({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getRealtimeHazardEventList(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGHAZARDEVENT_GETREALTIMEHAZARDEVENTLIST_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGHAZARDEVENT_GETREALTIMEHAZARDEVENTLIST_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgHazardEventServ_GetRealtimeInquireList({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getRealtimeInquireList(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGHAZARDEVENT_GETREALTIMEINQUIRELIST_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGHAZARDEVENT_GETREALTIMEINQUIRELIST_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_GdDlysjgHazardEvent_GetRealtimeHazardEventListResult: state => {
      return state.state_GdDlysjgHazardEvent_GetRealtimeHazardEventListResult;
    },
    get_GdDlysjgHazardEvent_GetRealtimeInquireListResult: state => {
      return state.state_GdDlysjgHazardEvent_GetRealtimeInquireListResult;
    },
  }
}